/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';

class Orientation extends Component {

  changeSelectedOrientation = () => {
    const {label, onClick, srcChange} = this.props;

    onClick(label, srcChange)
  }

  render() {
    const {
      className,
      classNameDiv,
      checkedI,
      label,
      value,
      selected,
      src,
      srcChange
    } = this.props;
    const classNameI = selected === label
      ? checkedI
      : '';
    const srcFinal = classNameI === ''
      ? srcChange
      : src;
    return (<div className={classNameDiv}>
      <a href="#" className={className} onClick={this.changeSelectedOrientation} style={{
          'maxHeight' : '98px'
        }}>
        <img src={srcFinal} alt='Orientation'/>
        <label>{value}</label>
        <i className={classNameI}></i>
      </a>
    </div>);
  }
}

export default Orientation;
